/**
 *@author       罗朝军
 *@date         2021/8/31 15:51
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
export default [
  {
    showLeftMenu: 1,
    code: "132000",
    auth: false,
    pcode: "",
    auths: [],
    type: 1,
    url: "/sourceManage",
    viewTemplate: "common-modules/layout/Layout",
    sons: [
      {
        showLeftMenu: 1,
        code: "132001",
        auth: false,
        pcode: "132000",
        auths: [],
        type: 1,
        url: "/sourceManage/sourceManageList",
        viewTemplate: "",
        sons: [
          {
            showLeftMenu: 1,
            code: "132002",
            auth: false,
            pcode: "132001",
            auths: [],
            type: 2, // 1菜单 2 页面
            url: "/sourceManage/expertManage/expertEvaluateList",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 0,
                code: "13203",
                auth: false,
                pcode: "132002",
                auths: [],
                type: 2,
                url: "/sourceManage/expertManage/expertEvaluateList",
                viewTemplate: "sourceManage/expertManage/expertEvaluateList",
                sons: [],
                name: "专家评标",
                id: 1402,
                isGroup: 0,
                keyword: "expertEvaluateList"
              }
            ],
            name: "专家评标",
            id: 1402,
            isGroup: 0,
            keyword: "expertEvaluateList"
          }
        ],
        name: "评标室",
        id: 1401,
        isGroup: 0,
        keyword: "sourceManage"
      }
    ],
    name: "评标室",
    id: 1400,
    isGroup: 0,
    keyword: "sourceManage"
  },

  {
    showLeftMenu: 1,
    code: "142000",
    auth: false,
    pcode: "",
    auths: [],
    type: 1,
    url: "/expertManage",
    viewTemplate: "common-modules/layout/Layout",
    sons: [
      {
        showLeftMenu: 0,
        code: "142001",
        auth: false,
        pcode: "142000",
        auths: [],
        type: 1,
        url: "/expertManage/expertManages",
        viewTemplate: "",
        sons: [
          {
            showLeftMenu: 1,
            code: "14203",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/perfectInformation",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14223",
                auth: false,
                pcode: "14203",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/perfectInformation/list",
                viewTemplate:
                  "sourceManage/expertManages/perfectInformation-list",
                sons: [],
                name: "信息完善列表",
                id: 1502,
                isGroup: 0,
                keyword: "perfectInformation"
              },
              {
                showLeftMenu: 0,
                code: "14310",
                auth: false,
                pcode: "14203",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/perfectInformation/edit",
                viewTemplate:
                  "sourceManage/expertManages/perfectInformation-edit",
                sons: [],
                name: "信息完善编辑",
                id: 1512,
                isGroup: 0,
                keyword: "perfectInformationEdit"
              },
              {
                showLeftMenu: 0,
                code: "14311",
                auth: false,
                pcode: "14203",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/perfectInformation/detail",
                viewTemplate:
                  "sourceManage/expertManages/perfectInformation-detail",
                sons: [],
                name: "信息完善查看",
                id: 1512,
                isGroup: 0,
                keyword: "perfectInformationDetail"
              }
            ],
            name: "信息完善",
            id: 1502,
            isGroup: 0,
            keyword: "perfectInformationEdit"
          },

          {
            showLeftMenu: 1,
            code: "14204",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/manageNnitAdd",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14312",
                auth: false,
                pcode: "14204",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/manageNnitAdd/list",
                viewTemplate: "sourceManage/expertManages/manageNnitAdd-list",
                sons: [],
                name: "管理单位新增列表",
                id: 1502,
                isGroup: 0,
                keyword: "manageNnitAddList"
              },
              {
                showLeftMenu: 0,
                code: "14313",
                auth: false,
                pcode: "14204",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/manageNnitAdd/edit",
                viewTemplate: "sourceManage/expertManages/manageNnitAdd-edit",
                sons: [],
                name: "管理单位新增编辑",
                id: 1512,
                isGroup: 0,
                keyword: "manageNnitAddEdit"
              },
              {
                showLeftMenu: 0,
                code: "14314",
                auth: false,
                pcode: "14204",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/manageNnitAdd/detail",
                viewTemplate: "sourceManage/expertManages/manageNnitAdd-detail",
                sons: [],
                name: "管理单位新增查看",
                id: 1512,
                isGroup: 0,
                keyword: "manageNnitAddDetail"
              }
            ],
            name: "管理单位新增",
            id: 1502,
            isGroup: 0,
            keyword: "manageNnitAdd"
          },

          {
            showLeftMenu: 1,
            code: "14205",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/changeInformation",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14315",
                auth: false,
                pcode: "14205",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeInformation/list",
                viewTemplate:
                  "sourceManage/expertManages/changeInformation-list",
                sons: [],
                name: "信息变更列表",
                id: 1502,
                isGroup: 0,
                keyword: "changeInformationList"
              },
              {
                showLeftMenu: 0,
                code: "14316",
                auth: false,
                pcode: "14205",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeInformation/edit",
                viewTemplate:
                  "sourceManage/expertManages/changeInformation-edit",
                sons: [],
                name: "信息变更编辑",
                id: 1512,
                isGroup: 0,
                keyword: "changeInformationEdit"
              },
              {
                showLeftMenu: 0,
                code: "14317",
                auth: false,
                pcode: "14205",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeInformation/detail",
                viewTemplate:
                  "sourceManage/expertManages/changeInformation-detail",
                sons: [],
                name: "信息变更查看",
                id: 1512,
                isGroup: 0,
                keyword: "changeInformationDetail"
              }
            ],
            name: "信息变更",
            id: 1502,
            isGroup: 0,
            keyword: "changeInformation"
          },

          {
            showLeftMenu: 1,
            code: "14206",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/changeAccount",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14318",
                auth: false,
                pcode: "14206",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeAccount/list",
                viewTemplate: "sourceManage/expertManages/changeAccount-edit",
                // viewTemplate: "sourceManage/expertManages/changeAccount-list",

                sons: [],
                name: "手机号变更列表",
                id: 1502,
                isGroup: 0,
                keyword: "changeAccountList"
              },
              {
                showLeftMenu: 0,
                code: "14319",
                auth: false,
                pcode: "14206",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeAccount/edit",
                viewTemplate: "sourceManage/expertManages/changeAccount-edit",
                sons: [],
                name: "手机号变更编辑",
                id: 1512,
                isGroup: 0,
                keyword: "changeAccountEdit"
              },
              {
                showLeftMenu: 0,
                code: "14320",
                auth: false,
                pcode: "14206",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changeAccount/detail",
                viewTemplate: "sourceManage/expertManages/changeAccount-detail",
                sons: [],
                name: "手机号变更查看",
                id: 1512,
                isGroup: 0,
                keyword: "changeAccountDetail"
              }
            ],
            name: "手机号变更",
            id: 1502,
            isGroup: 0,
            keyword: "changeAccount"
          },

          {
            showLeftMenu: 1,
            code: "14207",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/changePassword",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14322",
                auth: false,
                pcode: "14207",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changePassword/list",
                // viewTemplate: "sourceManage/expertManages/changePassword-list",
                viewTemplate: "sourceManage/expertManages/changePassword-edit",
                sons: [],
                name: "密码变更列表",
                id: 1502,
                isGroup: 0,
                keyword: "changePasswordList"
              },
              {
                showLeftMenu: 0,
                code: "14323",
                auth: false,
                pcode: "14207",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changePassword/edit",
                viewTemplate: "sourceManage/expertManages/changePassword-edit",
                sons: [],
                name: "密码变更编辑",
                id: 1512,
                isGroup: 0,
                keyword: "changePasswordEdit"
              },
              {
                showLeftMenu: 0,
                code: "14324",
                auth: false,
                pcode: "14207",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/changePassword/detail",
                viewTemplate:
                  "sourceManage/expertManages/changePassword-detail",
                sons: [],
                name: "密码变更查看",
                id: 1512,
                isGroup: 0,
                keyword: "changePasswordDetail"
              }
            ],
            name: "密码变更",
            id: 1502,
            isGroup: 0,
            keyword: "changePassword"
          },

          {
            showLeftMenu: 1,
            code: "14208",
            auth: false,
            pcode: "142001",
            auths: [],
            type: 1,
            url: "/expertManage/expertManages/outExpert",
            viewTemplate: "common-modules/parent-view/index",
            sons: [
              {
                showLeftMenu: 1,
                code: "14321",
                auth: false,
                pcode: "14208",
                auths: [],
                type: 2,
                url: "/expertManage/expertManages/outExpert/list",
                viewTemplate: "sourceManage/expertManages/outExpert-list",
                sons: [],
                name: "退出专家库列表",
                id: 1502,
                isGroup: 0,
                keyword: "outExpertList"
              }
            ],
            name: "退出专家库",
            id: 1502,
            isGroup: 0,
            keyword: "outExpert"
          }
        ],
        name: "专家信息维护",
        id: 1501,
        isGroup: 0,
        keyword: "expertManage"
      }
    ],
    name: "专家信息维护",
    id: 1500,
    isGroup: 0,
    keyword: "expertManage"
  }
];
